import dayjs from 'dayjs'

import {
  QuickInterval,
  TariffType
} from '@/api/models/parking/lib/parking.types'
import { toMskCalendarDate } from '@/utils/datetime'

import { getFirstBookableHour } from './getFirstBookableHour'

export const getRangeFromQuickInterval = (filter: QuickInterval) => {
  if (filter.type === TariffType.Daily) {
    return {
      from: toMskCalendarDate(filter.startDateTime),
      to: dayjs(toMskCalendarDate(filter.endDateTime))
        .subtract(1, 'day')
        .toDate()
    }
  }

  const start = dayjs(filter.startDateTime)
  const end = dayjs(filter.endDateTime)

  const firstBookableHour = getFirstBookableHour(Date.now())
  const shiftMs = start.isBefore(firstBookableHour)
    ? firstBookableHour.diff(start)
    : 0

  return {
    from: start.add(shiftMs, 'ms').toDate(),
    to: end.add(shiftMs, 'ms').toDate()
  }
}
